import { Component, OnInit, OnDestroy } from '@angular/core';
import { MonedoService } from 'src/app/core/services/monedo.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { SignalRService } from 'src/app/core/services/signalr.service';
import { MemoryStorageService } from 'src/app/core/services/memory-storage.service';

@Component({
  selector: 'app-consent',
  templateUrl: './consent.component.html',
  styleUrl: './consent.component.scss'
})
export class ConsentComponent implements OnInit, OnDestroy {

  consentUrl: SafeResourceUrl = '';
  loanId: string = '';
  private pollingInterval: any;

  constructor(
    private monedoServive: MonedoService,
    private sanitizer: DomSanitizer,
    private router: Router,
    private signalRService: SignalRService
  ) { }

  ngOnInit(): void {
    this.monedoServive.InitiateConsent({ lat: 10, lon: 10 }).subscribe({
      next: (response) => {
        if (response['data'] != null) {
          this.consentUrl = this.sanitizer.bypassSecurityTrustResourceUrl(response['data']['redirect_url']);
          this.loanId = response['data']['loan_id'];
        }
        // Start listening to SignalR only when we have the loanId
        this.startListening();
      },
      error: (err) => {
        console.error('Error initiating consent:', err);
      }
    });
  }

  // 1. Where you start the process (e.g. initiating the KYC or Consent)
  startListening() {
    const provider = 'monedo';
    const loanAppId = this.loanId;
    const eventType = 'crif';

    if (!loanAppId) return;

    this.monedoServive.getWebhookStatus(loanAppId, eventType).subscribe({
      next: (res) => {
        if (res.status === 'success') {
          this.router.navigateByUrl('/assist-journey/m/details');
          return;
        } else if (res.status === 'error' || res.status === 'expired' || res.status === 'failed') {
          this.router.navigateByUrl('/assist-journey/session-expired');
          return;
        }
      }
    });

    if (!this.signalRService.hubConnection) {
      const token = MemoryStorageService.getItem('customerToken');
      if (token) {
        this.signalRService.initSignalR(token);
      } else {
        console.error('Cannot initialize SignalR, missing customerToken');
        return;
      }
    }

    const tryJoinGroup = () => {
      if (this.signalRService.isConnected()) {
        if (this.pollingInterval) {
          clearInterval(this.pollingInterval);
          this.pollingInterval = null;
        }
        // Instruct SignalR to subscribe to ONLY this specific webhook's updates
        this.signalRService.hubConnection.invoke('JoinWebhookGroup', provider, loanAppId, eventType)
          .catch((err: any) => console.error('Error joining group:', err));

        // Listen for the unified "WebhookUpdate" event
        this.signalRService.hubConnection.on('WebhookUpdate', (payload: any) => {
          // Ensure the payload matches what we are looking for
          console.log('--- SIGNALR RAW PAYLOAD INCOMING ---', payload);

          if (payload.provider === provider && payload.uniqueId === loanAppId && payload.eventType === eventType) {

            console.log('Webhook Status Update:', payload.status);

            // DO YOUR ANGULAR UI UPDATES HERE (Routing, showing success message)
            if (payload.status === 'success') {
              this.router.navigateByUrl('/assist-journey/m/details');
            } else if (payload.status === 'error' || payload.status === 'expired' || payload.status === 'failed') {
              this.router.navigateByUrl('/assist-journey/session-expired');
            }

            if (payload.status !== 'pending') {
              this.stopListening(provider, loanAppId, eventType); // Cleanup!
            }
          }
        });
      }
    };

    // Attempt immediately, then poll if not yet connected 
    tryJoinGroup();
    if (!this.signalRService.isConnected() && !this.pollingInterval) {
      this.pollingInterval = setInterval(tryJoinGroup, 500);
    }
  }

  // 2. Ensure you stop listening when the webhook succeeds (or when leaving the page)
  stopListening(provider: string, loanAppId: string, eventType: string) {
    if (this.pollingInterval) {
      clearInterval(this.pollingInterval);
      this.pollingInterval = null;
    }
    if (this.signalRService.hubConnection) {
      this.signalRService.hubConnection.off('WebhookUpdate');

      if (this.signalRService.isConnected()) {
        this.signalRService.hubConnection.invoke('LeaveWebhookGroup', provider, loanAppId, eventType)
          .catch((err: any) => console.error('Error leaving group:', err));
      }
    }
  }

  ngOnDestroy(): void {
    // Ensure we clean up if the user navigates away before receiving a non-pending webhook status
    if (this.loanId) {
      this.stopListening('monedo', this.loanId, 'consent');
    }
  }
}
